import { Component, Inject, OnInit, Optional, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { FormsDataService } from '../../../core/services/forms-data.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { parseCommaSeparatedIds } from '../../../core/utils/parse-comma-ids';

export interface InputDialogConfirmationOpenData {
  showIntegrationIdsField?: boolean;
}

export interface InputDialogConfirmationResult {
  result: true;
  days_from_checkin: string | number | null;
  integration_ids?: number[];
}

@Component({
  selector: 'app-input-dialog-confirmation',
  standalone: true,
  imports: [
    MatIconModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './input-dialog-confirmation.component.html',
  styleUrl: './input-dialog-confirmation.component.scss',
})
export class InputDialogConfirmationComponent implements OnInit {
  form!: FormGroup;
  title = 'Run Task';
  readonly showIntegrationIdsField: boolean;
  FormsDataService = inject(FormsDataService);

  constructor(
    public dialogRef: MatDialogRef<InputDialogConfirmationComponent>,
    private fb: FormBuilder,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    private dialogData: InputDialogConfirmationOpenData | null
  ) {
    this.showIntegrationIdsField = !!dialogData?.showIntegrationIdsField;
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      integrationIdsText: [''],
      inputField: ['', [Validators.min(0)]],
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  closeConfirmedDialog() {
    if (this.showIntegrationIdsField) {
      const raw = this.form.get('integrationIdsText')?.value as string | null;
      const ids = parseCommaSeparatedIds(raw);
      if (!ids.length) {
        this.form.get('integrationIdsText')?.setErrors({ required: true });
        this.FormsDataService.showFormErrors(this.form);
        return;
      }
      this.form.get('integrationIdsText')?.setErrors(null);
    }

    if (!this.form.valid) {
      this.FormsDataService.showFormErrors(this.form);
      return;
    }

    const payload: InputDialogConfirmationResult = {
      result: true,
      days_from_checkin: this.form.get('inputField')?.value,
    };

    if (this.showIntegrationIdsField) {
      const raw = this.form.get('integrationIdsText')?.value as string | null;
      payload.integration_ids = parseCommaSeparatedIds(raw);
    }

    this.dialogRef.close(payload);
  }
}
